import(/* webpackMode: "eager" */ "/home/iktravels/domains/website/src/app/privacy-policy/page.tsx");
